// DEPENDENCIES
import React, { useState, useEffect, useContext } from "react";

// CSS
import "./ConfirmFolderMoveDialog.css";

// MSAL
import { useMsal } from "@azure/msal-react";

// API IMPORTS
import {
	deleteAPICall,
	postAPICall,
	putAPICall,
} from "../../../../config/apiCalls";

// CONTEXT
import { UserContext } from "../../../../context/UserContext";

// MUI COMPONENTS
import {
	Alert,
	Autocomplete,
	Button,
	CircularProgress,
	Dialog,
	DialogContent,
	DialogTitle,
	FormControl,
	IconButton,
	TextField,
} from "@mui/material";

// MUI ICONS
import CloseIcon from "@mui/icons-material/Close";

// CUSTOM COMPONENTS

// CONSTANTS

// OTHER

// REACT COMPONENT
const ConfirmFolderMoveDialog = (props) => {
	// MSAL
	const { instance, accounts } = useMsal();

	// STATES
	const [isLoading, setIsLoading] = useState(false);

	const [confirmButtonEnabled, setConfirmButtonEnabled] = useState(false);

	// EFFECTS
	useEffect(() => {
		if (props.open) {
			const timerId = setTimeout(() => {
				setConfirmButtonEnabled(true);
			}, 3000); // 3 seconds

			// Cleanup function to clear the timeout
			return () => {
				clearTimeout(timerId);
				setConfirmButtonEnabled(false);
			};
		}
	}, [props.open]); // Empty dependency array means it runs once on mount and cleans up on unmount

	const handleConfirmPressed = async () => {
		setIsLoading(true);
		setConfirmButtonEnabled(false);

		await props.handleConfirmPressed();

		setIsLoading(false);
	};

	// RENDER
	return (
		<Dialog
			id="ConfirmFolderMoveDialog"
			open={props.open}
			fullWidth
			onClose={props.onClose}
		>
			<DialogTitle
				id="ConfirmFolderMoveDialogTitle"
				sx={{
					backgroundColor: props.isArchiveSelected
						? "#B53943"
						: "#568C5B",
					color: "#FFFFFF",
				}}
			>
				Confirm Move
			</DialogTitle>
			{isLoading && (
				<div className="loadingSpinnerContainer">
					<CircularProgress />
				</div>
			)}
			{!isLoading && (
				<DialogContent id="ConfirmFolderMoveDialogContent">
					<div className="dialogContentContainer">
						Are you sure you want to move <b>{props.fromPath}</b> to{" "}
						<b>{props.toPath}</b>?
					</div>
					<div className="dialogActionsContainer">
						<Button
							variant="outlined"
							color="error"
							onClick={props.onClose}
						>
							Cancel
						</Button>
						<Button
							variant="contained"
							color="primary"
							onClick={handleConfirmPressed}
							disabled={!confirmButtonEnabled}
						>
							Confirm
						</Button>
					</div>
				</DialogContent>
			)}
		</Dialog>
	);
};

// EXPORT
export default ConfirmFolderMoveDialog;
